import React, {
  FC, Fragment, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { LinearProgress } from '@mui/material';
import { VaultButton } from '../../../Shared';
import {
  DialogHeader,
  DialogHeaderTitle,
} from '../../../Shared/styles/dialog';
import {
  ProgressContainer,
  FormSpacer,
} from './styles';
import { IDispatchProps, IProps, IStateProps } from './interfaces';
import { IAppState } from '../../../../state/reducers';
import { hydrateExchangeInfo } from '../../../../state/exchange/exchangeInfo';

const ExchangeInfo: FC<IProps> = (props: IProps) => {
  const { isLoading, infoFiles, getExchangeInfo } = props;

  useEffect(() => {
    if (!isLoading && !infoFiles) {
      getExchangeInfo();
    }
  }, [infoFiles]);

  function onUrlClick(url: string) {
    window.open(url);
  }

  return (
    <>
      <DialogHeader>
        <DialogHeaderTitle>
          Exchange Info
        </DialogHeaderTitle>
      </DialogHeader>
      <ProgressContainer>
        {isLoading && <LinearProgress />}
      </ProgressContainer>
      <>
        <FormSpacer />
        {!isLoading && infoFiles && (
          infoFiles.map((infoFile, i) => (
            <VaultButton
              key={infoFile.url}
              variant="transparentOnWhite"
              onClick={() => onUrlClick(infoFile.url)}
              data-auto={`ExchangeInfoBtn-${i}`}
            >
              {infoFile.name}
            </VaultButton>
          ))
        )}
        <FormSpacer />
      </>
    </>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  isLoading: state.exchange.exchangeInfo.isLoading,
  infoFiles: state.exchange.exchangeInfo.infoFiles,
});

const mapDispatchToProps: IDispatchProps = {
  getExchangeInfo: hydrateExchangeInfo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeInfo);
